import { useEffect, useRef, useState } from "react";
import { useMobxStores } from "../stores/stores";
import { observer } from "mobx-react";
import {
  Row,
  Col,
  Divider,
  Tabs,
  Card,
  Empty,
  Image,
  Typography,
  Grid,
} from "antd";
import { SettingOutlined } from "@ant-design/icons";
import ItemPreview from "../components/marketplace/ItemPreview";
import UserModalForm from "../components/profile/UserModalForm";
import { useParams } from "react-router-dom";
import ProfileGradientBackground from "../assets/profile-gradient-background.png";
import newPhoneProfileBackground from "../assets/newPhoneProfileBackground.svg";

import MobileProfileGradientBackground from "../assets/BackgroundPhone.png";
import LinkedinIcon from "../assets/social/linkedin-icon.png";
import XIcon from "../assets/social/x-icon.png";
import GlobeIcon from "../assets/social/web-icon.png";
import MastodonIcon from "../assets/social/mastodon-icon.png";
import InstagramIcon from "../assets/social/instagram-icon.png";
import FacebookIcon from "../assets/social/facebook-icon.png";
import GithubIcon from "../assets/social/github-icon.png";
import "./Profile.css";
const { useBreakpoint } = Grid;

const Profile = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm; // < md = mobile
  const { userStore, marketplaceStore } = useMobxStores();

  let params = useParams();

  useEffect(() => {
    marketplaceStore.GetMarketplaceItems();
    marketplaceStore.GetCreatedMarketplaceItems(params.username);
    marketplaceStore.GetOwnedMarketplaceItems(params.username);
    userStore.GetUserByUsername(params.username);
  }, [marketplaceStore, userStore, params]);

  useEffect(() => {
    function handleResize() {
      if (cardRef.current) {
        setBgHeight(cardRef.current.offsetHeight + 140);
      }
      if (cardPhoneRef.current) {
        setBgHeight(cardPhoneRef.current.offsetHeight + 220);
      }
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const cardRef = useRef(null);
  // const cardPhoneRef = useRef(null);
  // const [bgHeight, setBgHeight] = useState(null);
  // const [bgPhoneHeight, setBgPhoneHeight] = useState(null);

  useEffect(() => {
    if (cardRef.current) {
      const height = cardRef.current.offsetHeight;
      setBgPhoneHeight(height + 140); // +10px
    }
    if (cardPhoneRef.current) {
      const height = cardPhoneRef.current.offsetHeight;
      setBgPhoneHeight(height + 220); // +10px
    }
  }, [userStore.profileUser]); // re-run if profile data changes

  const cardRef = useRef(null);
  const cardPhoneRef = useRef(null);

  const [bgHeight, setBgHeight] = useState(0);
  const [bgPhoneHeight, setBgPhoneHeight] = useState(0);

  const updateBgHeights = () => {
    if (cardRef.current) setBgHeight(cardRef.current.offsetHeight + 140);
    if (cardPhoneRef.current)
      setBgPhoneHeight(cardPhoneRef.current.offsetHeight + 220);
  };

  useEffect(() => {
    updateBgHeights(); // ✅ run once on mount
    window.addEventListener("resize", updateBgHeights);
    return () => window.removeEventListener("resize", updateBgHeights);
  }, []);

  useEffect(() => {
    // ✅ run again when profile data comes in and the Card content changes
    updateBgHeights();
  }, [userStore.profileUser]);

  const items = [
    {
      key: "1",
      label: `Owned`,
      children: (
        <Row
          justify={"space-between"}
          align={
            marketplaceStore.OwnedMarketplaceItems.length === 0
              ? "center"
              : "middle"
          }
        >
          {marketplaceStore.OwnedMarketplaceItems.map((item) => {
            return (
              <Col xxl={{ flex: "20%" }} xl={8} md={12} sm={24} key={item.id}>
                <ItemPreview item={item} />
              </Col>
            );
          })}
          {marketplaceStore.OwnedMarketplaceItems.length === 0 && (
            <Empty description="No items found" />
          )}
        </Row>
      ),
    },
    {
      key: "2",
      label: `Created`,
      children: (
        <Row
          justify={"space-between"}
          align={
            marketplaceStore.CreatedMarketplaceItems.length === 0
              ? "center"
              : "middle"
          }
        >
          {marketplaceStore.CreatedMarketplaceItems.map((item) => {
            return (
              <Col xxl={{ flex: "20%" }} xl={8} md={12} sm={24} key={item.id}>
                <ItemPreview item={item} />
              </Col>
            );
          })}
          {marketplaceStore.CreatedMarketplaceItems.length === 0 && (
            <Empty description="No items found" />
          )}
        </Row>
      ),
    },
  ];

  return (
    <div style={{ marginBottom: "3%", marginTop: "50px" }}>
      {isMobile ? (
        <>
          {userStore.profileUser != null && (
            <>
              <Row align={"top"} justify={"center"} gutter={[10, 10]}>
                {/* <Divider /> */}
                <span>
                  <div
                    style={{
                      position: "relative",
                      marginTop: "-40px",

                      // display: "flex",
                      // justifyContent: "center",
                      // alignItems: "center",
                    }}
                  >
                    {/* Blurred background square */}
                    <div
                      style={{
                        // left: -10,
                        position: "absolute",
                        // inset: 0,

                        // left: "-90px",
                        // width: "760px",
                        // height: "740px",
                        backgroundImage: `url(${newPhoneProfileBackground})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        filter: "blur(20px)",
                        zIndex: 0,
                        marginTop: "-10px",
                        height: bgPhoneHeight ? `${bgPhoneHeight}px` : "0px", // dynamic height
                      }}
                      className="card-background"
                    />

                    <div>
                      {/* Foreground centered red square */}
                      <Card
                        // style={{
                        //   width: "50%",
                        // }}

                        ref={cardPhoneRef}
                        className="profile-card-phone"
                        // cover={
                        //   <Image
                        //     alt="user-photo-profile"
                        //     src={userStore.profileUser?.photo}
                        //     preview={false}
                        //   />
                        // }
                      >
                        <div>
                          {" "}
                          <div
                            style={{
                              color: "#000080",
                              fontWeight: "600",
                              textAlign: "start",
                              height: "fit-content",
                              marginBottom: "10px",
                            }}
                            className="profile-name"
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                fontSize: "28px",
                              }}
                            >
                              {userStore.profileUser.first_name}{" "}
                              {userStore.profileUser.last_name}
                              {userStore.user?.id ===
                                userStore.profileUser?.id && (
                                <SettingOutlined
                                  style={{
                                    fontSize: "20px",
                                    marginLeft: "16px",
                                    color: "rgba(0,0,128,0.5)",
                                  }}
                                  onClick={() =>
                                    userStore.setIsUserModalOpen(true)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>

                        <div
                          style={{
                            // width: "fit-content",
                            display: "flex",
                            direction: "column",
                            justifyContent: "start",
                          }}
                        >
                          <Image
                            style={{
                              borderRadius: "20px",
                              width: "46vw",
                              height: "auto",
                            }}
                            alt="user-photo-profile-phone"
                            src={userStore.profileUser?.photo}
                            preview={false}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "12px",
                              alignItems: "end",
                              marginTop: "12px",
                            }}
                          >
                            <Typography
                              style={{
                                color: "#000080",
                                fontSize: "16px",
                                lineHeight: "16px",
                                fontWeight: "300",
                                textAlign: "start",
                                width: "fit-content",
                              }}
                            >
                              {userStore.profileUser?.bio}
                            </Typography>
                          </div>
                          <div
                            style={{
                              textAlign: "start",
                              display: "flex",
                              gap: "8px",
                            }}
                          >
                            {userStore.profileUser?.linkedin && (
                              <button
                                className="social-button"
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.linkedin,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img
                                  style={{ width: "20px" }}
                                  src={LinkedinIcon}
                                  alt="linked in icon"
                                />
                              </button>
                            )}
                            {userStore.user?.x && (
                              <button
                                className="social-button"
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.x,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img
                                  style={{ width: "20px" }}
                                  src={XIcon}
                                  alt="x icon"
                                />
                              </button>
                            )}
                            {userStore.profileUser?.external_link && (
                              <button
                                className="social-button"
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.external_link,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img
                                  style={{ width: "20px" }}
                                  src={GlobeIcon}
                                  alt="globe icon"
                                />
                              </button>
                            )}
                            {userStore.profileUser?.mastodon && (
                              <button
                                className="social-button"
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.mastodon,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img
                                  style={{ width: "20px" }}
                                  src={MastodonIcon}
                                  alt="mastodon icon"
                                />
                              </button>
                            )}
                            {userStore.profileUser?.instagram && (
                              <button
                                className="social-button"
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.instagram,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img
                                  style={{ width: "20px" }}
                                  src={InstagramIcon}
                                  alt="instagram icon"
                                />
                              </button>
                            )}
                            {userStore.profileUser?.facebook && (
                              <button
                                className="social-button"
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.facebook,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img
                                  style={{ width: "20px" }}
                                  src={FacebookIcon}
                                  alt="facebook icon"
                                />
                              </button>
                            )}
                            {userStore.profileUser?.github && (
                              <button
                                className="social-button"
                                style={{ width: "20px" }}
                                onClick={() =>
                                  window.open(
                                    userStore.profileUser?.github,
                                    "_blank",
                                    "noopener,noreferrer"
                                  )
                                }
                              >
                                <img src={GithubIcon} alt="github icon" />
                              </button>
                            )}
                          </div>
                        </div>
                      </Card>
                    </div>
                  </div>
                </span>
              </Row>
              <Row
                style={{ marginTop: "-80px" }}
                align={"top"}
                justify={"center"}
                gutter={[10, 10]}
              >
                {/* <Divider /> */}
                <Tabs
                  className="profile-tabs"
                  defaultActiveKey="1"
                  items={items}
                />
              </Row>
            </>
          )}
        </>
      ) : (
        <>
          {userStore.profileUser != null && (
            <Row align={"top"} justify={"start"} gutter={[10, 10]}>
              {/* <Divider /> */}
              <span>
                <div
                  style={{
                    position: "relative",

                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                  }}
                >
                  {/* Blurred background square */}
                  <div
                    style={{
                      // left: -10,
                      position: "absolute",
                      // inset: 0,
                      // top: "-120px",
                      // left: "-90px",
                      // width: "760px",
                      // height: "740px",
                      backgroundImage: `url(${ProfileGradientBackground})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      filter: "blur(25px)",
                      zIndex: 0,
                      marginTop: "-10px",
                      height: bgHeight ? `${bgHeight}px` : "0px", // dynamic height
                    }}
                    className="card-background"
                  />

                  {/* Foreground centered red square */}
                  <Card
                    // style={{
                    //   width: "50%",
                    // }}
                    ref={cardRef}
                    className="profile-card"
                    cover={
                      <Image
                        alt="user-photo-profile"
                        src={userStore.profileUser?.photo}
                        preview={false}
                      />
                    }
                  >
                    <div
                      style={{
                        width: "fit-content",
                        display: "flex",
                        gap: "16px",
                      }}
                    >
                      <div
                        style={{
                          color: "#000080",
                          fontWeight: "600",
                          textAlign: "start",
                          height: "fit-content",
                        }}
                        className="profile-name"
                      >
                        {userStore.profileUser.first_name}{" "}
                        {userStore.profileUser.last_name}
                      </div>

                      {userStore.user?.id === userStore.profileUser?.id && (
                        <SettingOutlined
                          style={{
                            color: "rgba(0,0,128,0.5)",
                            fontSize: "18px",
                          }}
                          onClick={() => userStore.setIsUserModalOpen(true)}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "end",
                        }}
                      >
                        <Typography
                          style={{
                            color: "#000080",
                            fontSize: "16px",
                            lineHeight: "16px",
                            fontWeight: "300",
                            textAlign: "start",
                            width: "fit-content",
                          }}
                        >
                          {userStore.profileUser?.bio}
                        </Typography>
                      </div>
                      <div
                        style={{
                          textAlign: "start",
                          display: "flex",
                          gap: "8px",
                        }}
                      >
                        {userStore.profileUser?.linkedin && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.linkedin,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={LinkedinIcon} alt="linked in icon" />
                          </button>
                        )}
                        {userStore.user?.x && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.x,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={XIcon} alt="x icon" />
                          </button>
                        )}
                        {userStore.profileUser?.external_link && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.external_link,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={GlobeIcon} alt="globe icon" />
                          </button>
                        )}
                        {userStore.profileUser?.mastodon && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.mastodon,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={MastodonIcon} alt="mastodon icon" />
                          </button>
                        )}
                        {userStore.profileUser?.instagram && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.instagram,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={InstagramIcon} alt="instagram icon" />
                          </button>
                        )}
                        {userStore.profileUser?.facebook && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.facebook,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={FacebookIcon} alt="facebook icon" />
                          </button>
                        )}
                        {userStore.profileUser?.github && (
                          <button
                            className="social-button"
                            onClick={() =>
                              window.open(
                                userStore.profileUser?.github,
                                "_blank",
                                "noopener,noreferrer"
                              )
                            }
                          >
                            <img src={GithubIcon} alt="github icon" />
                          </button>
                        )}
                      </div>
                    </div>
                  </Card>
                </div>

                {/* <div
              style={{
                position: "absolute",
                // width: "100%",
                // height: "100%",
                backgroundImage: `url(${ProfileGradientBackground})`,
                filter: "blur(25px)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                top: -40,
                left: -110,
              }}
              className="card-background"
            />
            <Card
              // style={{
              //   width: "50%",
              // }}
              className="profile-card"
              cover={
                <Image
                  alt="user-photo-profile"
                  src={userStore.profileUser?.photo}
                  preview={false}
                />
              }
            >
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    color: "#000080",
                    fontWeight: "600",
                    textAlign: "start",
                    height: "fit-content",
                  }}
                  className="profile-name"
                >
                  {userStore.profileUser.first_name}{" "}
                  {userStore.profileUser.last_name}
                </div>
                {userStore.user?.id === userStore.profileUser?.id && (
                  <SettingOutlined
                    style={{
                      color: "rgba(0,0,128,0.5)",
                      fontSize: "18px",
                    }}
                    onClick={() => userStore.setIsUserModalOpen(true)}
                  />
                )}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "8px",
                }}
              >
                <div
                  style={{ display: "flex", gap: "12px", alignItems: "end" }}
                >
                  <Typography
                    style={{
                      color: "#000080",
                      fontSize: "16px",
                      lineHeight: "16px",
                      fontWeight: "300",
                      textAlign: "start",
                      width: "fit-content",
                    }}
                  >
                    {userStore.profileUser?.bio}
                  </Typography>
                </div>
                <div
                  style={{ textAlign: "start", display: "flex", gap: "8px" }}
                >
                  {userStore.profileUser?.linkedin && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.linkedin,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={LinkedinIcon} alt="linked in icon" />
                    </button>
                  )}
                  {userStore.user?.x && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.x,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={XIcon} alt="x icon" />
                    </button>
                  )}
                  {userStore.profileUser?.external_link && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.external_link,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={GlobeIcon} alt="globe icon" />
                    </button>
                  )}
                  {userStore.profileUser?.mastodon && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.mastodon,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={MastodonIcon} alt="mastodon icon" />
                    </button>
                  )}
                  {userStore.profileUser?.instagram && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.instagram,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={InstagramIcon} alt="instagram icon" />
                    </button>
                  )}
                  {userStore.profileUser?.facebook && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.facebook,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={FacebookIcon} alt="facebook icon" />
                    </button>
                  )}
                  {userStore.profileUser?.github && (
                    <button
                      className="social-button"
                      onClick={() =>
                        window.open(
                          userStore.profileUser?.github,
                          "_blank",
                          "noopener,noreferrer"
                        )
                      }
                    >
                      <img src={GithubIcon} alt="github icon" />
                    </button>
                  )}
                </div>
              </div>
            </Card> */}
              </span>
              <span>
                <Tabs
                  className="profile-tabs"
                  defaultActiveKey="1"
                  items={items}
                />
              </span>
            </Row>

            /* <Row align={"top"} justify={"space-around"} gutter={[10, 10]}>
<Divider />
<Col span={1} xl={1} xxl={1} md={1} sm={0} xs={0}></Col>
<Col
  span={7}
  xl={7}
  xxl={7}
  md={7}
  sm={24}
  xs={24}
  style={{
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    paddingTop: "42px",
  }}
>
  <div
    style={{
      position: "absolute",
      width: "100%",
      height: "100%",
      backgroundImage: `url(${ProfileGradientBackground})`,
      filter: "blur(25px)",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      top: 0,
      left: 0,
    }}
  />
  <Card
    style={{
      width: "68%",
    }}
    className="profile-card"
    cover={
      <Image
        alt="user-photo-profile"
        src={userStore.profileUser?.photo}
        preview={false}
      />
    }
  >
    <div
      style={{
        width: "fit-content",
        display: "flex",
        gap: "16px",
      }}
    >
      <div
        style={{
          color: "#000080",
          fontSize: "32px",
          fontWeight: "600",
          textAlign: "start",
          height: "fit-content",
        }}
      >
        {userStore.profileUser.first_name}{" "}
        {userStore.profileUser.last_name}
      </div>
      {userStore.user?.id === userStore.profileUser?.id && (
        <SettingOutlined
          style={{
            color: "rgba(0,0,128,0.5)",
            fontSize: "18px",
          }}
          onClick={() => userStore.setIsUserModalOpen(true)}
        />
      )}
    </div>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <div
        style={{ display: "flex", gap: "12px", alignItems: "end" }}
      >
        <Typography
          style={{
            color: "#000080",
            fontSize: "16px",
            lineHeight: "16px",
            fontWeight: "300",
            textAlign: "start",
            width: "fit-content",
          }}
        >
          {userStore.profileUser?.bio}
        </Typography>
      </div>
      <div
        style={{ textAlign: "start", display: "flex", gap: "8px" }}
      >
        {userStore.profileUser?.linkedin && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.linkedin,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={LinkedinIcon} alt="linked in icon" />
          </button>
        )}
        {userStore.user?.x && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.x,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={XIcon} alt="x icon" />
          </button>
        )}
        {userStore.profileUser?.external_link && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.external_link,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={GlobeIcon} alt="globe icon" />
          </button>
        )}
        {userStore.profileUser?.mastodon && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.mastodon,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={MastodonIcon} alt="mastodon icon" />
          </button>
        )}
        {userStore.profileUser?.instagram && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.instagram,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={InstagramIcon} alt="instagram icon" />
          </button>
        )}
        {userStore.profileUser?.facebook && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.facebook,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={FacebookIcon} alt="facebook icon" />
          </button>
        )}
        {userStore.profileUser?.github && (
          <button
            className="social-button"
            onClick={() =>
              window.open(
                userStore.profileUser?.github,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <img src={GithubIcon} alt="github icon" />
          </button>
        )}
      </div>
    </div>
  </Card>
</Col>
<Col span={15} xl={15} xxl={15} md={15} sm={24} xs={24}>
  <Tabs defaultActiveKey="1" items={items} />
</Col>
<Col span={1} xl={1} xxl={1} md={1} sm={0} xs={0}></Col>
</Row> */
          )}
        </>
      )}

      <UserModalForm />
    </div>
  );
};

export default observer(Profile);
